import React, { MouseEventHandler, PureComponent } from 'react';
import { MdFileDownload, MdPrint } from 'react-icons/md';

import './ActionLink.scss';

export interface ActionLinkProps {
  text?: string;
  icon?: string;
  link?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
}

export class ActionLink extends PureComponent<ActionLinkProps> {
  render() {
    return (
      <div className='ActionLink'>
        <a
          href={this.props.link || '#'}
          target='_brank'
          onClick={this.props.onClick}
        >
          {this.props.text}
          {this.props.icon ? (
            this.props.icon === 'print' ? (
              <MdPrint color='#007bff' style={{ marginLeft: 5 }} />
            ) : (
                <MdFileDownload color='#007bff' style={{ marginLeft: 5 }} />
              )
          ) : null}
        </a>
      </div>
    );
  }
}
